import { InjectableRxStompConfig } from "@stomp/ng2-stompjs";
import { environment } from "src/environments/environment";

export const stompConfig: InjectableRxStompConfig = {
    // Which server?
    brokerURL: environment.WS_URL,

    // Headers
    // Typical keys: login, passcode, host
    connectHeaders: {
        ACCESS_TOKEN: localStorage.getItem(environment.TOKEN_NAME)
    },

    // How often to heartbeat?
    // Interval in milliseconds, set to 0 to disable
    heartbeatIncoming: 0, // Typical value 0 - disabled
    heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

    // Wait in milliseconds before attempting auto reconnect
    // Set to 0 to disable
    // Typical value 500 (500 milli seconds)
    reconnectDelay: 200,

    // Will log diagnostics on console
    // It can be quite verbose, not recommended in production
    // Skip this key to stop logging to console
    debug: (msg: string): void => {
      if (environment.SHOW_DEBUG) {
        console.log(new Date(), msg);
      }
    },

  beforeConnect: (client) => {
    if(!localStorage.getItem(environment.TOKEN_NAME)){
      client['_stompClient'].reconnectDelay = 0;
    }else{
      client['_stompClient'].reconnectDelay = 200;
    }
  }
};
